// Centralized business information

export const businessHours = [
  { id: 'sun', day: 'Sunday', dayAr: 'الأحد', hours: '10 AM - 10 PM' },
  { id: 'mon', day: 'Monday', dayAr: 'الإثنين', hours: '10 AM - 10 PM' },
  { id: 'tue', day: 'Tuesday', dayAr: 'الثلاثاء', hours: '10 AM - 10 PM' },
  { id: 'wed', day: 'Wednesday', dayAr: 'الأربعاء', hours: '10 AM - 10 PM' },
  { id: 'thu', day: 'Thursday', dayAr: 'الخميس', hours: '10 AM - 10 PM' },
  { id: 'fri', day: 'Friday', dayAr: 'الجمعة', hours: '10 AM - 11 PM' },
  { id: 'sat', day: 'Saturday', dayAr: 'السبت', hours: '10 AM - 11 PM' }
];

export const socialLinks = {
  instagram: 'https://www.instagram.com/salamgrilltx/',
  facebook: 'https://www.facebook.com/p/Salam-Grill-61578756717646/',
  doordash: 'https://www.doordash.com/store/40092379',
  ubereats: 'https://www.ubereats.com/store/salam-grill-329-n-greenville-ave/IzmCVc6xTkydUF2Bk5ji7w?diningMode=PICKUP&surfaceName=',
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_charcoal-flames/artifacts/h6qtljok_IMG_6775-removebg-preview.png';

export const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3347.068547685886!2d-96.70850482346486!3d32.95036807250259!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c1ff6371b63c1%3A0xfb84f1ff7fa2b2b2!2s329%20N%20Greenville%20Ave%2C%20Richardson%2C%20TX%2075081%2C%20USA!5e0!3m2!1sen!2s!4v1703123456789!5m2!1sen!2s';

export const DIRECTIONS_URL = 'https://www.google.com/maps/dir//329+N+Greenville+Ave,+Richardson,+TX+75081,+United+States';

export const HERO_BG_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/cbb1ce90-450b-4c81-88c0-4fc7565b631d/images/13851abf7749a65cbfb817d687e9161454ba21bbb728d04a8a86a76e8f72e0a5.png';

export const EXPERIENCE_IMAGES = [
  'https://customer-assets.emergentagent.com/job_charcoal-flames/artifacts/qorr8b8l_WhatsApp%20Image%202026-04-06%20at%2000.14.06.jpeg',
  'https://customer-assets.emergentagent.com/job_charcoal-flames/artifacts/wppvy3g7_WhatsApp%20Image%202026-04-06%20at%2000.14.22.jpeg'
];
